module.exports = __webpack_public_path__ + "img/keyboard_2.bb333508.png";